import { useImmerAtom } from 'jotai-immer';
import {
    monitorStatusTableViewAtom,
    monitorStatusTableFiltersAtom,
    monitorStatusTableStatsAtom,
    monitorStatusDataAtom,
} from './monitorstatus_atoms';
import { useTableData } from '../../../../core/table/hooks/useTableData';
import { MonitorItem } from '../../data/datamonitorRepo';

export const useMonitorStatusData = (): { items: MonitorItem[] } => {
    const [view] = useImmerAtom(monitorStatusTableViewAtom);
    const [filters] = useImmerAtom(monitorStatusTableFiltersAtom);
    const [stats, setStats] = useImmerAtom(monitorStatusTableStatsAtom);
    const [data] = useImmerAtom(monitorStatusDataAtom);

    const { items } = useTableData<MonitorItem>({
        view,
        filters,
        stats,
        data,
        setStats,
    });

    return { items };
};
